/**
 * Created by mozartdiniz on 12/2/14.
 */

Greenmile.Survey.Sidebar.ENTITY = function () {

    Greenmile.Survey.Sidebar.Generic.apply(this, arguments);

    this.resourceKey = 'general.entity';
    this.jsonType = 'ENTITY';
    this.fields = {};
    this.templateID = 'SurveyEntityTemplate';
    var customNamespace = 'SurveyQuestionEntity';

    App.Forms[customNamespace] = App.Forms[customNamespace] || {};

    this.prepareForUpdate = function () {

    };

    this.generateFields = async function () {

        var description = new Monet.UI.Fields.Render(
            {
                "name": "description",
                "label": "Survey.new.question.header",
                "description": "description",
                "type": "TEXT",
                "mandatory": true,
                "maxSize": 255
            }).render();

        var entity = new Monet.UI.Fields.PickListAutoComplete();
        entity.setValue({
            id: null,
            name: ''
        });

        const data = {"criteriaChain":[{"and":[{"attr":"visibleToCustomer","eq":"true"}]}]};

        const ajax = new Monet.Ajax();
        ajax.url = '/EntityRest/restrictions?criteria={"filters":["id","name"]}';
        ajax.method = 'post';
        ajax.async = false;
        ajax.data = JSON.stringify(data);

        ajax.success = (response) => {
            const fieldDomains = response.map(item => {
                return {
                    text: item.name,
                    ...item
                };
            });
            entity.setFieldDomains(fieldDomains);
        };

        await ajax.send();

        entity.render();
        entity.setTextLabel(Monet.I18n.getResourcesByKey('general.entity'));

        entity.onSelectCallback = (value) => {
            App.Forms.SurveyQuestionEntity = App.Forms.SurveyQuestionEntity || {};
            var grid = App.Forms.SurveyQuestionEntity.table;

            if (grid && grid.getData().data.length) {

                const confirmChangeEntity = () => {
                    if (App.Forms.SurveyQuestionEntityCached) {
                        const cacheGrid = App.Forms.SurveyQuestionEntityCached.gridCache;
                        cacheGrid.destroy();
                    }
                    this.mountFilterBuilder(value);
                };

                new Greenmile.Components.AlertModal('Survey.confirmChangeData',
                    null,
                    confirmChangeEntity)
                .show();
            } else {
                this.mountFilterBuilder(value);
            }
        };

        this.fields.description = description;
        this.fields.entity = entity;

        this.fields.entityAvoidDuplicateSelection = new Monet.UI.Fields.Render(
            {
                "name": "entityAvoidDuplicateSelection",
                "label": "Survey.new.question.entityAvoidDuplicateSelection",
                "description": "Survey.new.question.entityAvoidDuplicateSelection",
                "type": "CHECKBOX",
                "mandatory": false,
                "maxSize": 255
            }).render();

        return {
            description: description,
            entity: entity,
            entityAvoidDuplicateSelection: this.fields.entityAvoidDuplicateSelection
        };

    }.bind(this);

    this.setCallBackAfterListEntity = function (entity) {

        if (entity.filter) {
            entity.filter.setCallbackBeforeFilter(function () {

                if (this.criteriaChain.criteriaChain[0]) {
                    this.criteriaChain.criteriaChain[0].and.push({ "attr": "visibleToCustomer", "eq": "true" });
                }

            });
        }

    };

    this.didRenderTemplate = async function (question, parentQuestionId) {
        this.rootEl = document.querySelector('.entityQuestionContainer');
        var rowHeader = this.rootEl.querySelector('.SingleRowHeader');
        var fields = await this.generateFields();
        App.Forms[customNamespace].headerFields = fields;

        delete App.Forms.SurveyQuestionEntity.questionData;
        delete App.Forms.SurveyQuestionEntity.table;

        if (question && question.entity) {
            fields.description.setValue(question.question);
            fields.entity.setValue(question.entity);

            fields.entityAvoidDuplicateSelection.setValue(question.entityAvoidDuplicateSelection);

            var entity = fields.entity.getValue();
            if (entity.name) {
                entity = entity.name;
            }
            this.mountFilterBuilder(entity, question);
        }

        rowHeader.appendChild(fields.description.rootEl);
        rowHeader.appendChild(fields.entity.rootEl);

        if (!parentQuestionId) {
            rowHeader.appendChild(fields.entityAvoidDuplicateSelection.rootEl);
        }

        this.setCallBackAfterListEntity(fields.entity);

    }.bind(this);

    this.createGridCache = function (question) {
        var entity = App.Forms.SurveyQuestionEntity.headerFields.entity.getFullValue();
        if (entity.name) {
            entity = entity.name;
        }
        var grid = new Greenmile.Survey.Sidebar.EntityGridCache(entity);
        grid.createGrid();
        grid.setQuestionData(question);
        grid.cacheResults(App.Forms.SurveyQuestionEntity.table);
    };


    this.addCacheStructure = function (rootEl) {

        var buttonParent = rootEl.querySelector('.gridActionsCache');
        var button = buttonParent.querySelector('#btnCacheField');

        if (button) {
            buttonParent.removeChild(button);
        }

        var btnCacheResults = new Monet.UI.Fields.Render(
            {
                "name": "btnCacheField",
                "label": "Survey.Entity.cacheResults",
                "description": "btnCacheField",
                "type": "BUTTON",
                "mandatory": true
            }).render();

        var saveResults = function () {
            if (!App.Forms.SurveyQuestionEntity.table.getItemsSelected().length) {
                new Greenmile.Components.AlertModal('Greenmile.actionGridButton.noItemChecked')
                    .show();
                return;
            }

            if (App.Forms.SurveyQuestionEntityCached) {
                var t = App.Forms.SurveyQuestionEntityCached.gridCache;
                t.addItems(App.Forms.SurveyQuestionEntity.table.getItemsSelected());
            } else {
                this.createGridCache();
            }

        }.bind(this);

        btnCacheResults.addEventClickListener(saveResults);
        buttonParent.appendChild(btnCacheResults.rootEl);

    };

    this.mountFilterBuilder = function (entity, question) {
        App.Forms[entity] = App.Forms[entity] || {};
        App.Forms[entity].layout = App.Forms[entity].layout || {};
        var layout = App.Forms[entity].layout.index;
        var pageLayout = new Monet.PageLayout();
        var projection = (question ? question.entityProjection : null);
        var restriction = (question ? question.entityRestriction : null);

        var callbackAfterBuild = function (layout) {
            if (projection) {
                layout = Greenmile.Utils.createGridLayoutFromProjection.parse(entity.key || entity, projection);
            }

            var content = document.querySelector('#EntityQuestion .content');
            content.style.display = 'block';

            var grid = new Greenmile.Survey.Sidebar.EntityGrid(entity);
            grid.createGrid(layout);

            if (restriction) {
                App.Forms.SurveyQuestionEntity.filterBuilder.setFieldsByRestriction(restriction);
            }

            this.addCacheStructure(document.querySelector('.entityQuestionContainer .content'));
            if (App.Forms.SurveyQuestionEntityCached) {
                delete App.Forms.SurveyQuestionEntityCached;
            }

            if (question && question.entityRestriction) {
                var restrictionObj = JSON.parse(question.entityRestriction);
                var ands = restrictionObj.criteriaChain[0].and;
                for (var i in ands) {
                    if (ands[i].in) {
                        this.createGridCache(question);
                        break;
                    }
                }
            }

        }.bind(this);

        var createGrid = function () {
            layout = JSON.parse(JSON.stringify(App.Forms[entity].layout.index));

            App.Forms.SurveyQuestionEntity.fields = null;
            App.Forms.SurveyQuestionEntity.dataMapper = null;

            var dm = new Monet.Builder.DataMapper();
            dm.setEntity(entity);
            dm.build((function (layout) {
                return function () {
                    callbackAfterBuild(layout);
                };
            }(layout)), layout);
        };

        if (layout) {
            createGrid();
        } else {
            pageLayout.getLayout(entity, 'index', createGrid);
        }

    };

    this.serializeInput = function () {
        var headerFields = App.Forms.SurveyQuestionEntity.headerFields;
        var description = headerFields.description.getValue();
        var entity = headerFields.entity.getValue();
        var nameSpace = App.Forms[customNamespace];
        var filterBuilder = nameSpace.filterBuilder;
        var cachedGridNamespace = App.Forms.SurveyQuestionEntityCached;
        var cachedGrid = (cachedGridNamespace ? cachedGridNamespace.table : null);
        var projection = (filterBuilder ? App.Objects.Survey.getProjectionBasedOnIndex(customNamespace) : '');
        var criteriaObj = (filterBuilder ? filterBuilder.getCriteriaChain() : '');

        var answerOptions = [];

        if (cachedGrid) {
            var cache = cachedGrid.getData().data;

            var ids = cache.map(function (item) {
                return item.idOfObject.toString();
            });

            if (ids && ids.length) {

                var sort = (criteriaObj ? criteriaObj.sort : null);

                criteriaObj = {
                    "criteriaChain": [{
                        "and": []
                    }]
                };

                if (ids && ids.length) {
                    criteriaObj.criteriaChain[0].and.push({ attr: "id", in: ids });
                }

                if (sort) {
                    criteriaObj.sort = sort;
                }
            }
        }

        var criteria = (criteriaObj ? JSON.stringify(criteriaObj) : '');

        if (projection) {
            var projectionObj = JSON.parse(projection);
            projectionObj.firstResult = 0;
            projectionObj.maxResults = 1000;
            projection = JSON.stringify(projectionObj);
        }

        return {
            entityAvoidDuplicateSelection: headerFields.entityAvoidDuplicateSelection.getValue(),
            questionType: "ENTITY",
            questionText: description,
            entity: entity,
            projection: projection,
            criteria: criteria,
            answerOptions: answerOptions
        };

    };

    this.addQuestionContent = async function (questionContent, input) {
        var answerContent = questionContent.querySelector('.answerContent'),
            newQuestionDescription = questionContent.querySelector('.newQuestionDescription'),
            headerFields = await this.generateFields(),
            description = headerFields.description;

        App.Forms.SurveyQuestionEntity.questionData = input.questionData;
        description.setValue(input.questionData.question);
        headerFields.entity.setValue(input.questionData.entity);
        headerFields.entity.disable();

        newQuestionDescription.title = description.getValue();
        newQuestionDescription.innerHTML = description.getValue();

        answerContent.innerHTML = '';
        answerContent.appendChild(headerFields.entity.rootEl);
        this.addPreviewGrid(answerContent, input.questionData);

        questionContent.setAttribute('questionType', input.questionType);

        $('div[question_id="' + questionContent.getAttribute('question_id') + '"] .answerContent').sortable({ axis: "y" });

        this.setCallBackAfterListEntity(headerFields.entity);

    };

    this.addPreviewGrid = function (parent, question) {
        var gridContainerCache = document.createElement('div');
        gridContainerCache.className = 'gridPreviewContainer';
        gridContainerCache.setAttribute('question_id', question.id);

        parent.appendChild(gridContainerCache);

        var grid = new Greenmile.Survey.Sidebar.EntityGridPreview(question);
        this.grid = grid;
        grid.createGrid();

    };

};
